import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "home py-56"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "professionals-actions" }
const _hoisted_5 = { class: "h4 title text-primary mb-32" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "fw-normal" }, "Hola, ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-calendar me-12",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "professionals-consultations" }
const _hoisted_10 = { class: "h4 title text-primary mb-32" }
const _hoisted_11 = { class: "fw-normal" }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = { class: "professionals-patients" }
const _hoisted_14 = { class: "h4 title text-primary mb-32" }
const _hoisted_15 = { class: "fw-normal" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_patient_consultations = _resolveComponent("v-patient-consultations")!
  const _component_the_patient_list_professionals = _resolveComponent("the-patient-list-professionals")!

  return (_ctx.authUser)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h2", _hoisted_5, [
                _hoisted_6,
                _createTextVNode(" " + _toDisplayString(_ctx.user.name), 1)
              ]),
              (_ctx.can('patient.calendar-event.index'))
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: {name: 'patient.calendar.show'},
                    class: "btn btn-primary btn-icon btn-md w-100 mb-8",
                    "aria-label": _ctx.$t('Modificar mi agenda')
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('Consultar mi agenda')), 1)
                    ]),
                    _: 1
                  }, 8, ["to", "aria-label"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("h2", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('Últimas')), 1),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('consultas')), 1)
              ]),
              (_ctx.status === 'loaded')
                ? (_openBlock(), _createBlock(_component_v_patient_consultations, {
                    key: 0,
                    consultations: _ctx.consultations,
                    "show-professional": true,
                    "go-show-consultation": true
                  }, null, 8, ["consultations"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("h2", _hoisted_14, [
                _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('Tus')), 1),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('profesionales')), 1)
              ]),
              _createVNode(_component_the_patient_list_professionals, { class: "py-12 px-8 mb-24" })
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}